const min1024 = window.matchMedia('(min-width: 1024px)');
let isDesktop = min1024.matches;

// Add content top padding to account for the fixed header size
// and help Android and (especially) iOS Safari work nice (with fixed menus)
(function() {
    const header = document.querySelector('.header');
    const content = document.querySelector('.content');

    // Attach debounced function to fire 200ms after last resize event
    window.addEventListener('resize', _.debounce(onWindowResize, 200));

    function onWindowResize() {
        // Update isDesktop
        isDesktop = min1024.matches

        // Set appropriate top padding on .content element
        // to account for the fixed header
        content.style.paddingTop = header.getBoundingClientRect().height + 'px';
    }

    let scrollY = window.srollY;
    const headerHeight = header.getBoundingClientRect().height;
    // Make Header slide up/down based on the scroll direction
    window.addEventListener('scroll', _.throttle(onWindowScroll, 200));

    function onWindowScroll() {
        const newScrollY = window.scrollY;

        //  Early exit if the scrolled amount is lower than header height
        if (newScrollY < headerHeight) {
            return false;
        }

        if (newScrollY > scrollY) {
            header.classList.add('header--scroll-up');
        } else {
            header.classList.remove('header--scroll-up');
        }

        scrollY = newScrollY;
    }
})();

// Header dropdown / aria a11y
(function() {
    const wraps = document.getElementsByClassName('header__menu-item--children');

    // Loop through each link and add event handlers
    for (var i = 0; i < wraps.length; i++) {
        const link = wraps[i];
        const toggle = link.querySelector('button');

        link.addEventListener('mouseenter', toggleDropdown.bind(link, true), false)
        link.addEventListener('mouseleave', toggleDropdown.bind(link, true), false)
        toggle.addEventListener('click', onToggleClick.bind(link), false)
    }

    function toggleDropdown(desktopOnly) {
        if (desktopOnly && !isDesktop) {
            return false
        }

        const isOpen = this.classList.contains('header__menu-item--show');
        this.classList.toggle('header__menu-item--show');

        // Update aria state
        this.children[0].setAttribute('aria-expanded', !isOpen)

        // Loop through the links and update tabIndex
        const links = this.children[1].getElementsByClassName('header__menu-link')
        for (var i = 0; i < links.length; i++) {
            links[i].setAttribute('tabIndex', isOpen ? 0 : -1)
        }
    }

    function onToggleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleDropdown.call(this);
    }
})();

// Custom "Filter"component 
(function($) {
    $('.filter').on('click', 'button', function() {
        $(this).closest('.filter').toggleClass('filter--active');
    });
})(jQuery);

// Header hamburger / offcanvas toggler
(function() {
    const wrap = document.querySelector('.header-menu-wrap')
    const toggle = document.querySelector('.header__hamburger');
    const overlay = document.querySelector('.offcanvas-overlay');

    function onHamburgerClick() {
        document.body.classList.toggle('offcanvas-show');

        // Enable/Disable body scroll lock for mobile menu wrap
        // so iOS devices don't freak out
        if (document.body.classList.contains('offcanvas-show')) {
            bodyScrollLock.disableBodyScroll(wrap)
        } else {
            bodyScrollLock.enableBodyScroll(wrap)
        }
    }

    toggle.addEventListener('click', onHamburgerClick, false)
    overlay.addEventListener('click', onHamburgerClick, false)
})();

(function() {
  // Accordion
  const accordions = document.getElementsByClassName('accordion');

  for (let i = 0; i < accordions.length; i++) {
    const accordion = accordions[i];
    const panels = accordion.getElementsByClassName('accordion__panel');

    for (let j = 0; j < panels.length; j++) {
      const panel = panels[j];
      const header = panel.querySelector('header');

      header.addEventListener('click', onAccordionHeaderClick.bind(panel));
      header.addEventListener('keydown', onAccordionHeaderClick.bind(panel));
    }
  }

  function onAccordionHeaderClick(e) {
    if (e.keyCode && e.keyCode !== 13) {
      return false;
    }

    const targetPanel = this;
    const isExpanded = targetPanel.classList.contains('accordion__panel--active');

    if (isExpanded) {
      // Reset other accordion body heights
      targetPanel.classList.remove('accordion__panel--active');
      targetPanel.querySelector('.accordion__header').setAttribute('aria-expanded', 'false');
      targetPanel.querySelector('.accordion__body').style.maxHeight = '0px';
    } else {
      // Expand in the next frame
      setTimeout(function() {
        const body = targetPanel.querySelector('.accordion__body');
        targetPanel.querySelector('.accordion__header').setAttribute('aria-expanded', 'true');
        const maxHeight = body.children[0].offsetHeight;

        targetPanel.classList.add('accordion__panel--active');
        body.style.maxHeight = maxHeight + 'px';
      }, 1);
    }
  }

})();

// Hash scroller
(function($) {
    window.scrollTo(0, 0); // attempt to remove jankiness like a chump
    const hash = window.location.hash;
    const header = document.querySelector('.header');
    const headerHeight = header.getBoundingClientRect().height;
    const negativeOffset = headerHeight + 70; // add some extra breathing room

    window.addEventListener('hashchange', onHashChange);
    onHashChange();
    function onHashChange() {
        if (hash) {
            const el = $(hash);
            if (el.length) {
                $('html, body').animate({
                    scrollTop: el.offset().top - negativeOffset
                }, 900);
            }
        }
    }
})(jQuery);
